export default __webpack_public_path__ + "static/media/realitybytes_xl.ed332290.jpg";